import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { ProductSearchItem, ProductSuggestionClickHandler } from '../../../model';
import { SEARCH_TEST_ID } from '../../../test/test-ids';
import { ConnectedProductCardSmall } from '../../ConnectedProductCardSmall/ConnectedProductCardSmall';
import { SectionHeading, SuggestionsCardsWrapper } from '../SearchSuggestions.styles';

type Props = {
    products: ProductSearchItem[];
    onClick?: ProductSuggestionClickHandler;
};

const SEARCH_SUGGESTIONS_PRODUCTS = 'search-suggestions-products';

export const ProductsSuggestions: FC<Props> = ({ products, onClick }) => {
    const { t } = useTranslations();

    return (
        <section data-test={SEARCH_TEST_ID.SUGGESTIONS_PRODUCTS} aria-labelledby={SEARCH_SUGGESTIONS_PRODUCTS}>
            <SectionHeading tag="h2" variant="title-100" id={SEARCH_SUGGESTIONS_PRODUCTS}>
                {t['search.suggestions.products.title']}
            </SectionHeading>
            <SuggestionsCardsWrapper>
                {products.map((product) => (
                    <ConnectedProductCardSmall
                        key={product.id}
                        product={product}
                        onClick={(event) => onClick?.(product, event)}
                    />
                ))}
            </SuggestionsCardsWrapper>
        </section>
    );
};
